var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.266,
    height: 15.266,
    viewBox: "0 0 15.266 15.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M15.88,9.185H12.153a.533.533,0,1,1,0-1.065H15.88a.533.533,0,1,1,0,1.065Z",
    transform: "translate(-3.007 -1.992)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M6.685,9.293a.527.527,0,0,1-.376-.156L5.777,8.6a.532.532,0,0,1,.753-.753l.156.156L7.907,6.787a.532.532,0,0,1,.753.753l-1.6,1.6a.532.532,0,0,1-.376.156Z",
    transform: "translate(-1.268 -1.561)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M15.88,16.185H12.153a.533.533,0,1,1,0-1.065H15.88a.533.533,0,0,1,0,1.065Z",
    transform: "translate(-3.007 -4.022)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M6.685,16.293a.527.527,0,0,1-.376-.156L5.777,15.6a.532.532,0,1,1,.753-.753l.156.156,1.221-1.221a.532.532,0,0,1,.753.753l-1.6,1.6a.532.532,0,0,1-.376.156Z",
    transform: "translate(-1.268 -3.591)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M11.013,16.516H6.753c-3.855,0-5.5-1.647-5.5-5.5V6.753c0-3.855,1.647-5.5,5.5-5.5h4.26c3.855,0,5.5,1.647,5.5,5.5v4.26C16.516,14.868,14.868,16.516,11.013,16.516Zm-4.26-14.2c-3.273,0-4.438,1.164-4.438,4.438v4.26c0,3.273,1.164,4.438,4.438,4.438h4.26c3.273,0,4.438-1.164,4.438-4.438V6.753c0-3.273-1.164-4.438-4.438-4.438Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewicon);
export default __webpack_public_path__ + "static/media/reviewicon.2e6111c06f734ba3dc744f64fb56230b.svg";
export { ForwardRef as ReactComponent };